import React, { useState, useEffect } from 'react';
import { database } from '../firebase';
import { ref, set, onValue, update, get } from 'firebase/database';
import '../styles/global.css';

const AdminMaintenance = () => {
    const [appConfig, setAppConfig] = useState({});
    const [loading, setLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false);
    const [systemStats, setSystemStats] = useState(null);

    const getSystemStats = async () => {
        try {
            const stats = { totalUsers: 0, activeUsers: 0, premiumUsers: 0, totalNotifications: 0 };
            
            // Contar usuarios
            const usersRef = ref(database, 'users');
            const usersSnapshot = await get(usersRef);
            if (usersSnapshot.exists()) {
                const users = usersSnapshot.val();
                stats.totalUsers = Object.keys(users).length;
                stats.premiumUsers = Object.values(users).filter(user => user.isPremium).length;
                stats.activeUsers = Object.values(users).filter(user =>
                    user.lastLogin && (Date.now() - user.lastLogin) < (30 * 24 * 60 * 60 * 1000)
                ).length;
            }

            // Contar notificaciones
            const notificationsRef = ref(database, 'notifications');
            const notificationsSnapshot = await get(notificationsRef);
            if (notificationsSnapshot.exists()) {
                const notifications = notificationsSnapshot.val();
                stats.totalNotifications = Object.values(notifications).reduce((total, userNotifications) =>
                    total + (userNotifications ? Object.keys(userNotifications).length : 0), 0
                );
            }
            return stats;
        } catch (error) {
            console.error('Error obteniendo estadísticas:', error);
            return null;
        }
    };

    useEffect(() => {
        const loadStats = async () => {
            const stats = await getSystemStats();
            setSystemStats(stats);
        };
        loadStats();
    }, []);

    useEffect(() => {
        const configRef = ref(database, 'appConfig');

        const unsubConfig = onValue(configRef, (snapshot) => {
            if (snapshot.exists()) setAppConfig(snapshot.val());
        });

        setLoading(false);
        return () => {
            unsubConfig();
        };
    }, []);

    const handleUpdateConfig = async (updates) => {
        setIsUpdating(true);
        try {
            const finalUpdates = {
                ...updates,
                lastUpdated: Date.now(),
                updatedBy: 'admin'
            };
            await update(ref(database, 'appConfig'), finalUpdates);
            alert('Configuración actualizada');
        } catch (e) {
            alert('Error: ' + e.message);
        } finally {
            setIsUpdating(false);
        }
    };

    const handleClearPending = async () => {
        if (!window.confirm('¿Limpiar registros de acciones pendientes?')) return;
        try {
            await set(ref(database, 'admin_actions'), null);
            alert('Acciones limpiadas');
        } catch (e) {
            alert('Error: ' + e.message);
        }
    };

    if (loading) return <div className="loading">Cargando mantenimiento...</div>;

    return (
        <div className="admin-maintenance" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <h1 style={{ color: 'var(--accent)' }}>Área de Mantenimiento y Control</h1>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                {/* COLUMNA IZQUIERDA: CONFIGURACIÓN */}
                <div>
                    {/* MODO MANTENIMIENTO */}
                    <div className="card" style={{ marginBottom: '20px', background: 'var(--bg-secondary)', padding: '20px', borderRadius: '12px', border: appConfig.maintenanceMode ? '2px solid #e74c3c' : '1px solid #444' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h2>Modo Mantenimiento</h2>
                                <p style={{ fontSize: '0.8rem', opacity: 0.7 }}>Bloquea el acceso a la app.</p>
                            </div>
                            <button
                                onClick={() => handleUpdateConfig({ maintenanceMode: !appConfig.maintenanceMode })}
                                disabled={isUpdating}
                                style={{
                                    padding: '10px 20px',
                                    background: appConfig.maintenanceMode ? '#e74c3c' : '#2ecc71',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold'
                                }}
                            >
                                {appConfig.maintenanceMode ? '🔴 ACTIVADO' : '⚪ DESACTIVADO'}
                            </button>
                        </div>
                    </div>

                    {/* EDITOR DE appConfig */}
                    <div className="card" style={{ background: 'var(--bg-secondary)', padding: '20px', borderRadius: '12px', marginBottom: '20px' }}>
                        <h2>Configuración General (RTDB)</h2>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '15px' }}>
                            <div>
                                <label  style={{  display: 'block' }} className="adm-label">Min Version Code</label>
                                <input
                                    type="number"
                                    value={appConfig.minVersionCode || ''}
                                    onChange={(e) => setAppConfig({ ...appConfig, minVersionCode: parseInt(e.target.value) })}
                                    style={{ width: '100%', padding: '8px', background: 'var(--bg-primary)', color: 'white', border: '1px solid #444', borderRadius: '4px' }}
                                />
                            </div>
                            <div>
                                <label  style={{  display: 'block' }} className="adm-label">Max Users Per Day</label>
                                <input
                                    type="number"
                                    value={appConfig.maxUsersPerDay || ''}
                                    onChange={(e) => setAppConfig({ ...appConfig, maxUsersPerDay: parseInt(e.target.value) })}
                                    style={{ width: '100%', padding: '8px', background: 'var(--bg-primary)', color: 'white', border: '1px solid #444', borderRadius: '4px' }}
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: '15px' }}>
                            <label  style={{  display: 'block' }} className="adm-label">URL de Actualización</label>
                            <input
                                type="text"
                                value={appConfig.updateUrl || ''}
                                onChange={(e) => setAppConfig({ ...appConfig, updateUrl: e.target.value })}
                                style={{ width: '100%', padding: '8px', background: 'var(--bg-primary)', color: 'white', border: '1px solid #444', borderRadius: '4px' }}
                            />
                        </div>

                        <div style={{ display: 'flex', gap: '15px', marginTop: '15px' }}>
                            <label  style={{  display: 'flex',  alignItems: 'center',  gap: '8px' }} className="adm-label">
                                <input type="checkbox" checked={appConfig.allowLogin || false} onChange={(e) => handleUpdateConfig({ allowLogin: e.target.checked })} /> Allow Login
                            </label>
                            <label  style={{  display: 'flex',  alignItems: 'center',  gap: '8px' }} className="adm-label">
                                <input type="checkbox" checked={appConfig.allowRegistration || false} onChange={(e) => handleUpdateConfig({ allowRegistration: e.target.checked })} /> Allow Reg.
                            </label>
                            <label  style={{  display: 'flex',  alignItems: 'center',  gap: '8px' }} className="adm-label">
                                <input type="checkbox" checked={appConfig.forceUpdate || false} onChange={(e) => handleUpdateConfig({ forceUpdate: e.target.checked })} /> Force Update
                            </label>
                        </div>

                        <div style={{ marginTop: '15px' }}>
                            <label  style={{  display: 'block' }} className="adm-label">Mensaje de Mantenimiento</label>
                            <textarea
                                value={appConfig.maintenanceMessage || ''}
                                onChange={(e) => setAppConfig({ ...appConfig, maintenanceMessage: e.target.value })}
                                style={{ width: '100%', padding: '8px', background: 'var(--bg-primary)', color: 'white', border: '1px solid #444', borderRadius: '4px', minHeight: '60px' }}
                            />
                        </div>

                        <button
                            onClick={() => handleUpdateConfig(appConfig)}
                            disabled={isUpdating}
                            style={{ marginTop: '15px', width: '100%', padding: '12px', background: 'var(--accent)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                        >
                            {isUpdating ? 'Guardando...' : '💾 Guardar Todo appConfig'}
                        </button>
                    </div>
                </div>

                {/* COLUMNA DERECHA: HERRAMIENTAS Y AVISOS */}
                <div>
                    <div className="card" style={{ marginBottom: '20px', background: 'var(--bg-secondary)', padding: '20px', borderRadius: '12px' }}>
                        <h2>Herramientas de Sistema</h2>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '15px' }}>
                            <button
                                onClick={async () => {
                                    if (!window.confirm('¿Forzar sincronización?')) return;
                                    await set(ref(database, 'admin_actions/database_update'), {
                                        timestamp: Date.now(),
                                        action: 'force_database_sync',
                                        status: 'pending'
                                    });
                                    alert('Sincronización enviada');
                                }}
                                style={{ background: '#3498db', color: 'white', padding: '12px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                            >
                                🔄 Forzar Sync DB
                            </button>

                            <button
                                onClick={handleClearPending}
                                 className="adm-btn adm-btn--secondary"
                            >
                                🧹 Limpiar Acciones
                            </button>
                            <button
                                onClick={() => handleUpdateConfig({ global_message: '' })}
                                style={{ background: '#95a5a6', color: 'white', padding: '12px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                            >
                                🚫 Reset Aviso
                            </button>
                        </div>
                    </div>

                    <div className="card" style={{ background: 'var(--bg-secondary)', padding: '20px', borderRadius: '12px' }}>
                        <h2>Aviso Global (Banner)</h2>
                        <textarea
                            value={appConfig.global_message || ''}
                            onChange={(e) => setAppConfig({ ...appConfig, global_message: e.target.value })}
                            style={{ width: '100%', minHeight: '80px', background: 'var(--bg-primary)', color: 'white', padding: '10px', borderRadius: '6px', marginTop: '10px', border: '1px solid #444' }}
                        />
                        <button
                            onClick={() => handleUpdateConfig({ global_message: appConfig.global_message })}
                            style={{ marginTop: '10px', padding: '10px 20px', background: 'var(--accent)', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer' }}
                        >
                            📢 Publicar Aviso
                        </button>
                    </div>
                    <div className="card" style={{ background: 'var(--bg-secondary)', padding: '20px', borderRadius: '12px', marginTop: '20px' }}>
                        <h2>Estadísticas del Sistema</h2>
                        {systemStats ? (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '15px' }}>
                                <div style={{ background: 'rgba(56, 189, 248, 0.1)', border: '1px solid #38bdf8', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#38bdf8' }}>{systemStats.totalUsers}</div>
                                    <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>Usuarios Totales</div>
                                </div>
                                <div style={{ background: 'rgba(16, 185, 129, 0.1)', border: '1px solid #10b981', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#10b981' }}>{systemStats.activeUsers}</div>
                                    <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>Activos (30 días)</div>
                                </div>
                                <div style={{ background: 'rgba(245, 158, 11, 0.1)', border: '1px solid #f59e0b', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#f59e0b' }}>{systemStats.premiumUsers}</div>
                                    <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>Usuarios Premium</div>
                                </div>
                                <div style={{ background: 'rgba(197, 160, 89, 0.1)', border: '1px solid #c5a059', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#c5a059' }}>{systemStats.totalNotifications}</div>
                                    <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>Notifs Enviadas</div>
                                </div>
                            </div>
                        ) : (
                            <div style={{ marginTop: '15px', opacity: 0.6 }}>Cargando estadísticas...</div>
                        )}
                    </div>
                </div>
            </div>


        </div>
    );
};

export default AdminMaintenance;
